import React from 'react'
import { H2 } from '@hub/heading'
import { Box } from '@hub/box'
import PageLanding from '@scentregroup/shared/components/page-landing-v2'
import TableOfContents from '@scentregroup/shared/components/table-of-contents'
import { Markdown } from '@scentregroup/shared/hub-components/markdown'
import {
  TermsModule,
  Promotion,
  ComparisonModule,
  PromotionFeature,
  isTermsModule,
} from '@scentregroup/shared/types/content-page'

interface ContentPageProps {
  modules: (Promotion | PromotionFeature | ComparisonModule | TermsModule)[]
  title: string
}

/**
 * used by the terms-and-conditions and privacy-policy pages
 */
const ContentPage: React.FunctionComponent<
  React.PropsWithChildren<ContentPageProps>
> = ({ title, modules }) => {
  const termsModules = modules.filter(isTermsModule)
  return (
    <PageLanding heading={title} dataTestId="page-title" logo={undefined}>
      <Box
        sx={{
          maxWidth: '656px',
          paddingX: ['spacing-5', 'spacing-5', 'spacing-5', '0'],
        }}
      >
        <TableOfContents sections={termsModules} />
        {termsModules.map(module => (
          <Box
            key={module.slug}
            marginTop={{
              base: 'spacing-xl',
            }}
          >
            <H2
              color="textPrimary"
              sx={{
                fontSize: ['font-xl', 'font-2xl', 'font-4xl'],
                marginBottom: 'spacing-md',
              }}
              id={module.slug}
            >
              {module.title}
            </H2>
            <Markdown content={module.bodyCopy} key={module.slug} />
          </Box>
        ))}
      </Box>
    </PageLanding>
  )
}

export default ContentPage
